import mapFunction from './mapResources';

export default mapFunction('working_hours', {
    isFetching: false,
    items: [] 
});